import React, {useContext, useEffect} from "react";
import {ScreenDesignerContextNew} from "../../../../../../../../ContextComponents/ScreenDesignerContextNew";
import {TreeView} from "@material-ui/lab";
import RenderItems from "./RenderItems";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import findByString from "../../../../../../../../Utils/Form/FormDynamic/Utils/getValueByString";

const Navigator = ({setPanelType}) => {
    const {
        screenValues,
        selectedComponent = {path: undefined},
        onSelectComponent
    } = useContext(ScreenDesignerContextNew)
    const [expanded, setExpanded] = React.useState([]);


    useEffect(() => {
        if (selectedComponent && selectedComponent.path) {
            const expanded = generateExpanded(selectedComponent.path)
            setExpanded(expanded)
            return
        }
        setExpanded(["root"])

    }, [selectedComponent?.path]);

    function onNodeSelect(path) {
        const execPath = path === 'root' ? "" : path;
        const findValue = findByString(screenValues, execPath)
        onSelectComponent(execPath ? findValue : {...screenValues, type: 'container'}, execPath);
    }

    function generateExpanded(path) {
        const splitedPath = path.split('children');
        let values = ["root"];
        for (let i = 0; i < splitedPath.length; i++) {
            const currentValue = splitedPath[i] || "";
            const prev = values[i - 1] === 'root' ? "" : values[i - 1] || "";
            const path = currentValue ? prev + "children" + currentValue : ""
            currentValue && values.push(path)
        }
        return values.map(v => {
            const isPoint = v[v.length - 1] === '.';
            return isPoint ? v.substring(0, v.length - 1) : v;
        })
    }

    return (
        <div>
            <TreeView
                selected={selectedComponent ? selectedComponent.path : ""}
                onNodeSelect={(e, nodeId) => onNodeSelect(nodeId)}
                onDoubleClick={() => setPanelType('general')}
                defaultCollapseIcon={<ArrowDropDownIcon/>}
                expanded={expanded}
                defaultExpandIcon={<ArrowRightIcon/>}
                defaultEndIcon={<div style={{width: 24}}/>}
            >
                {RenderItems({items: [{type: 'Container', children: screenValues.children}], level: 0, root: true, setPanelType})}
            </TreeView>
        </div>
    )
};
export default Navigator